import { Grid, Container } from "@mui/material";
import BackgroundImage from "@components/BackgroundImageCst";
import CardHomeCst from "@components/CardHomeCst";
import { useTranslation } from "react-i18next";
import Breadcrumb from "@components/Breadcrumb";
import HeroCst from "@components/HeroCst";
import { useFetchDataDetail, useFetchDetail } from "@hooks/useFetchDetail";
import { useParams } from "react-router-dom";
import { useAuth } from "@context/auth";
import { useNavigaionRoutes } from "@hooks/useNavigation";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import AnimationFadeIn from "@components/AnimationFadeIn";
import { useResetFilters } from "@hooks/useFiltersProvider";
import { useFilteredBadge } from "../../../../hooks/useFilteredBadge";
import useTIMFunctionality from "@hooks/useTIMFunctionality";
import ModalDownloadUploadCst from "@components/ModalDownloadUploadCst";
import { useEffect, useState } from "react";
import ModalConfirmsCst from "@components/ModalConfirmsCst";

const DetailCorporate: React.FC = () => {
  const { t } = useTranslation(["corporate-detail-page", "common"]);
  const { id } = useParams();
  const { dataDetail } = useFetchDetail(
    ServicesURL.corporate,
    id || "",
    PagesID.corporate,
  );
  const { dataDetail: campaigns } = useFetchDataDetail(
    dataDetail?.collect_campaigns
      ? ServicesURL.findCampaignsAdmin.replace(":corporateId", id ?? "")
      : null,
    PagesID.corporate,
  );
  const { user } = useAuth();
  const {
    IsTIM,
    corporateCatalogActionsCards,
    configData,
    setConfigData,
    openCatalogTIM,
    setOpenCatalogTIM,
    setOpenToast,
    openToast,
  } = useTIMFunctionality();
  const navigation = useNavigaionRoutes();

  // https://yem2kwxkwk.execute-api.eu-central-1.amazonaws.com/test/nonymous-embed?user=${user?.id_user}&corporate=${user?.organization_id}

  useResetFilters();

  let menuItem = [];
  menuItem = navigation
    .find((el) => el.to === "corporate")
    ?.children?.filter((el: { section: string; to: string }) => {
      return (
        user?.permissions?.includes(el.section) &&
        (el.to !== "selfsignup" ||
          (dataDetail &&
            (dataDetail["self_signup"] === "LEARNER" ||
              dataDetail["self_signup"] === "MANAGER")))
      );
    });

  //INIZIO per poter visualizzare la sezione GESTIONE FINANZIATA  bisogna censirla sulla corporate desiderata tramite apposito campo presente in add/edit corporate
  menuItem = menuItem
    .filter((el: any) => {
      if (
        el.section === "usermgmt.corporates.funded_training.write" &&
        !dataDetail?.enable_funded_training
      ) {
        return;
      } else {
        return el;
      }
    })
    .filter((el: any) => {
      if (el.section === "usermgmt.corporates.collect_campaign.read") {
        return (
          dataDetail.collect_campaigns &&
          (!!(campaigns?.output as object[] | undefined)?.length ||
            user?.permissions.find(
              (permission) =>
                permission === "usermgmt.corporates.collect_campaign.create",
            ))
        );
      } else {
        return !!el;
      }
    });
  // FINE
  menuItem = useFilteredBadge(
    menuItem,
    dataDetail,
    ["enable_training_needs", "enable_budget"],
    ["usermgmt.corporates.training_needs"],
  );

  return (
    <AnimationFadeIn>
      <BackgroundImage
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-corporate.jpg"
        position={"absolute"}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={`${dataDetail?.name ? `${dataDetail?.name} - ${t("hero-title")}` : t("hero-title")}`}
          description={t("hero-description")}
        />
        <Grid container spacing={3}>
          {menuItem &&
            menuItem.map(
              (
                {
                  text,
                  section,
                  external,
                  image,
                  to,
                  link,
                  description,
                  buttonLabel,
                  disabled,
                  settingsLink,
                  permissionSettingsLink,
                  actionsCard,
                }: any,
                index: React.Key | null | undefined,
              ) => (
                <Grid key={index} item xs={12} md={6} lg={4}>
                  <CardHomeCst
                    image={image}
                    title={text}
                    description={description}
                    secondaryBtnLabel={buttonLabel}
                    to={to ? to : link}
                    externalLink={external}
                    disabled={disabled}
                    settingsLink={
                      user?.permissions.find(
                        (permission) => permission === permissionSettingsLink,
                      )
                        ? settingsLink
                        : null
                    }
                    actionsCard={
                      section === "corporate.catalog" && IsTIM()
                        ? corporateCatalogActionsCards
                        : []
                    }
                  />
                </Grid>
              ),
            )}
        </Grid>
      </Container>
      <ModalDownloadUploadCst
        open={openCatalogTIM}
        setOpen={() => {
          setOpenCatalogTIM(false);
          setConfigData(undefined);
        }}
        title={configData && configData.labelTranslate}
        data={configData}
      />
      <ModalConfirmsCst
        open={!!openToast}
        title={""}
        description={""}
        onCallBackClosed={() => {
          setOpenToast(undefined);
        }}
        status={openToast}
        routeToSamePage={true}
      />
    </AnimationFadeIn>
  );
};

export default DetailCorporate;
